import React from 'react';
import img1 from '../../images/gallery/1.webp';
import img2 from '../../images/gallery/2.webp';
import img3 from '../../images/gallery/3.webp';
import './Gallery.css';
const Gallery = () => {
    return (
        <div className="container gallery-block mt-4" id='Gallery'>
            <h1 className='text-center gallery'>Gallery</h1>
            <div className="row">
                <div className="col-md-4 col-sm-6">
                    <div className="card">
                        <img className="card-img-top" src={img1} alt="Card cap" />
                    </div>
                </div>
                <div className="col-md-4 col-sm-6">
                    <div className="card">
                        <img className="card-img-top" src={img2} alt="Card cap" />
                    </div>
                </div>
                <div className="col-md-4 col-sm-6">
                    <div className="card">
                        <img className="card-img-top" src={img3} alt="Card cap" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Gallery;